export default class AuthSuiteSdkProvider {}
